export default __webpack_public_path__ + "static/media/Q3.d40d9ba2.jpg";